import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Role, Permission } from '@/services/rolesPermissionsService';

interface AssignRolesModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedPermission: Permission | null;
  roles: Role[];
  selectedRoles: number[];
  onToggleRole: (roleId: number) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
  onSubmit: () => void;
  isLoading: boolean;
}

export const AssignRolesModal: React.FC<AssignRolesModalProps> = ({
  isOpen,
  onClose,
  selectedPermission,
  roles,
  selectedRoles,
  onToggleRole,
  onSelectAll,
  onDeselectAll,
  onSubmit,
  isLoading
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      if (!open) onClose();
    }}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>
            Gestionar roles para: {selectedPermission?.display_name || selectedPermission?.name}
          </DialogTitle>
          <DialogDescription>
            Selecciona o deselecciona los roles que deben tener este permiso.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex gap-2 mb-4">
            <Button 
              type="button" 
              variant="outline" 
              size="sm"
              onClick={onSelectAll}
            >
              Seleccionar Todos
            </Button>
            <Button 
              type="button" 
              variant="outline" 
              size="sm"
              onClick={onDeselectAll}
            >
              Deseleccionar Todos
            </Button>
          </div>
          <div className="max-h-[50dvh] overflow-y-auto space-y-2">
            {roles
              .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
              .map((role) => (
              <div key={role.id} className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded-md">
                <Checkbox
                  id={`role-${role.id}`}
                  checked={selectedRoles.includes(role.id)}
                  onCheckedChange={() => onToggleRole(role.id)}
                />
                <Label 
                  htmlFor={`role-${role.id}`}
                  className="flex-1 cursor-pointer"
                >
                  <div className="flex items-center gap-2">
                    <div 
                      className="w-3 h-3 rounded-full" 
                      style={{ backgroundColor: role.color || '#6b7280' }}
                    />
                    <div>
                      <div className="font-medium">
                        {role.display_name || role.name}
                      </div>
                      <div className="text-sm text-muted-foreground">
                        {role.description || 'Sin descripción'}
                      </div>
                    </div>
                  </div>
                </Label>
              </div>
            ))}
          </div>
          <div className="flex gap-2 pt-4">
            <Button 
              onClick={onSubmit}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center gap-2">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  Sincronizando...
                </div>
              ) : (
                'Sincronizar Roles'
              )}
            </Button>
            <Button 
              variant="outline" 
              onClick={onClose}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};